import React from 'react'
import { useState } from 'react';
import axios from 'axios';
//Adding a new brand through post
function AddBrand() {
    const [name, setName] = useState(''); 
    const [code, setCode] = useState('');
    const [active, setActive] = useState(true);
    const [img, setimg] = useState('');
    const sendData =  async (e) =>{
        try {
            e.preventDefault();
          const formData = new FormData();
          formData.append('Name', name);
          formData.append('Code', code);
          formData.append('img',img);
            axios.post(process.env.REACT_APP_API_URL+'/api/brands', formData).then((res) => {
                window.location.href = "/brand";
                })
            
        } catch (error) {
          console.error(error);
          console.log(process.env.REACT_APP_API_URL,"endpoint");
        }
      };
  return (
    <>
        <div className='flex justify-center'>
                
                    <form  className='bg-white w-1/2 ' onSubmit={sendData} >
                    <h1 className='text-2xl font-semibold mt-4'>Add Brand</h1>
                        <div className="flex flex-col">
                        <label
                            htmlFor="brand"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Brand
                        </label>
                        <input
                            type="text"
                            name="brand"
                            id="brand"
                            autoComplete="brand"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setName(e.target.value)}
                            placeholder='Enter Brand Name'
                        ></input>
                        </div>
                        <div className="flex flex-col">
                        <label
                            htmlFor="code"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Code
                        </label>
                        <input
                            type="text"
                            name="code"
                            id="code"
                            autoComplete="code"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            placeholder='Enter Brand Code'
                            onChange={(e)=>setCode(e.target.value)}
                        ></input>
                        </div>
                        <div className="flex flex-col">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Active
                        </label>
                        <select
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setActive(e.target.value)}
                        >
                            <option value="true">Active</option>
                            <option value="false">Disabled</option>
                        </select>
                        
                            <label
                                htmlFor="brand"
                                className="block text-sm font-medium text-gray-700 mt-4"
                            >
                                Logo
                            </label>
                            <input
                                type="file"
                                name="img"
                                id="img"
                                onChange={(e)=>setimg(e.target.files[0])}
                                autoComplete="img"
                                className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            ></input>
                        </div>
                        <button
                        type="submit"
                        className="mt-4 rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                        >
                        Add Brand
                        </button>
                    </form>
                </div>
    </>
  )
}

export default AddBrand